import { DEFAULT_PAGE } from '../../constants/pagination';
import {
  COST_ACCOUNTING_DEFAULT_SORT_COLUMN,
  COST_ACCOUNTING_SORT_ORDER,
} from '../../constants/sort';
import { SortOrder } from '../sort/sort';

export interface CostAccountingGetQueryParams {
  page: number;
  sortOrder: SortOrder;
  sortKey: string;
  startDate: string | null;
  endDate: string | null;
  projectId: number | null;
}

export const DefaultCostAccountingGetQueryParams: CostAccountingGetQueryParams =
  {
    page: DEFAULT_PAGE,
    sortOrder: COST_ACCOUNTING_SORT_ORDER,
    sortKey: COST_ACCOUNTING_DEFAULT_SORT_COLUMN,
    startDate: null,
    endDate: null,
    projectId: null,
  };
